import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Legacy ``/search`` route. The page now lives at ``/finder`` — this route is
 * kept only to redirect old links (bookmarks, copilot-emitted paths, the
 * extension, marketing emails) to the new canonical path, forwarding any
 * search params (tab/listId/aiFilters/q) untouched.
 */
const searchParamsSchema = z.object({
  // .catch: an unknown value (stale link, typo) falls back instead of
  // throwing, which crashed the whole page ("This page couldn't load").
  tab: z
    .enum(['people', 'companies'])
    .optional()
    .default('people')
    .catch('people'),
  listId: z.string().optional(),
  aiFilters: z.string().optional(),
  q: z.string().optional(),
});

export const Route = createFileRoute('/search')({
  validateSearch: searchParamsSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/finder', search, replace: true });
  },
});
